import DocLargeSVG from '../Icons/DocLargeSVG.svg';
import CvIconContainer from './CvIconContainer';
import UIStrings from '@/Utils/UIStrings';

function DocLargeIcon() {
    return (
        <CvIconContainer>
            <object
                className="h-full"
                type="image/svg+xml"
                data={DocLargeSVG}
                aria-label={UIStrings.DocDocx}
                data-cy="DocLargeIcon"
            />
        </CvIconContainer>
    );
}
export default DocLargeIcon;
